module.exports = __webpack_public_path__ + "img/receive_04.png";